import Link from 'next/link';

import styles from './breadcrumbs.component.module.scss';

export type BreadcrumbItem = {
  active?: boolean;
  link?: string;
  name?: string;
  onClick?: () => void;
};

type Props = {
  items: undefined | null | BreadcrumbItem[];
};

export const Breadcrumbs = (props: Props) => {
  const { items } = props;

  if (!items || items.length === 0) return null;

  return (
    <nav aria-label="breadcrumb">
      <ol className={styles.breadcrumbList}>
        {items.map((item, i) => {
          if (item.active) {
            return (
              <li aria-current="page" className={styles.active} key={i}>
                {item.name}
              </li>
            );
          }
          return (
            <li key={i}>
              {typeof item.link === 'string' ? (
                <Link href={item.link} onClick={item.onClick}>
                  {item.name}
                </Link>
              ) : (
                <button
                  className={styles.linkButton}
                  type="button"
                  onClick={item.onClick}
                >
                  {item.name}
                </button>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
